import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { getMessageFromActions } from 'js/hooks/server';
import { LAYER, useSmartClosePopups } from 'js/components/common/PopupManager';
import { closePopupsAction } from 'js/components/common/PopupManager/store/actions';
import { useMultiFactorAuthenticationPopup } from 'js/components/popups/MultiFactorAuthenticationPopup';

import { VALIDATION_TYPE } from '../constants';

export const useValidateMFA = () => {
    const dispatch = useDispatch();
    const closePopups = useSmartClosePopups();
    const showMultiFactorAuthenticationPopup = useMultiFactorAuthenticationPopup();

    return useCallback((pasLoginResponse) => new Promise((resolve, reject) => {
        const { sessionValidationData = {} } = pasLoginResponse?.data || {};

        if (!sessionValidationData.SessionValidationByMfaData) {
            resolve();

            return;
        }

        let isValid = false;
        const {
            provider,
            properties
        } = sessionValidationData.SessionValidationByMfaData[0] ?? {};

        showMultiFactorAuthenticationPopup({
            id: VALIDATION_TYPE.MULTI_FACTOR_AUTHENTICATION,
            title: getMessageFromActions(pasLoginResponse),
            onSuccess: () => {
                isValid = true;
                dispatch(closePopupsAction({ popups: [VALIDATION_TYPE.MULTI_FACTOR_AUTHENTICATION] }));
                resolve();
            },
            onCancel: () => {
                if (!isValid) {
                    closePopups({ excludeLayers: [LAYER.LOGIN] });
                    reject(pasLoginResponse);
                }
            },
            provider,
            properties
        });
    }), [
        showMultiFactorAuthenticationPopup, closePopups, dispatch
    ]);
};
